import { Component, OnInit, input, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorMessageService } from '@app/shared/services/material-error-message.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@Component({
    selector: 'material-form-select',
    templateUrl: './form-select.component.html',
    styleUrls: ['./form-select.component.scss'],
    imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule]
})
export class FormSelectComponent implements OnInit {
  private errorMessageService = inject(ErrorMessageService);

  readonly control = input<FormControl>(undefined);
  readonly title = input<string>(undefined);
  readonly list = input(undefined);

  ngOnInit() {
  }

  getError() {
    return this.errorMessageService.getErrorMessageUsingFormControl(this.control());
  }

}
